import * as angular from "angular";

function ScheduleTemplateAPI() {
  return {
    base: `/scheduleTemplate`,
    infiniteScroll: {
      address: `/scheduleTemplate`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getById: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      getTemplateAgents: {
        address: '{id}/agents',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}

angular
  .module('bringoz.admin.schedule')
  .factory('ScheduleTemplateAPI', ScheduleTemplateAPI);
